import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
  @Input() progress = 0;
  @Input() color: string;
  @Input() isCircleStyle = true;

  constructor() { }

  ngOnInit(): void {
  }

}
